//Staging

export const environment = {
  production: false,
  SERVER_HOST: "https://atzid.com",
  SERVER_ATZ_HOST: "https://staging-api.atzpay.com/api/",
  SERVER_DESIBOX_HOST: "https://staging-api.desibox.co/api/",
  mapbox: {
    accessToken:
      "pk.eyJ1Ijoic2VsbG51IiwiYSI6ImNrNTU5MmVsdDBycDEza3Q3ZGprcXQwMTMifQ.0WOgZMi7JdoS4tXkXIW_dg",
  },
};
